export default {
    OPEN_MODAL (state, value) {
        state.modal.isOpen = value;
        state.modal.data = {
            name: '',
            classification_id: null,
        };
    },
    SET_MODAL_DATA (state, data) {
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            state.modal.data[keys[i]] = data[keys[i]];
        }
    },
    SET_OPEN_CHANGELOG (state, value) {
        state.changelogOpen = value;
    },
    REARRANGE_ITEMS (state, items) {
        if (Array.isArray(items) && items.length) {
            Object.values(items).forEach((item, index) => {
                item.priority = index + 1;
            })
            state.items = items;
        }
    },
    REARRANGE_CLASSIFICATIONS (state, items) {
        if (Array.isArray(items) && items.length) {
            Object.values(items).forEach((item, index) => {
                item.priority = index + 1;
            })
            state.classifications = items;
        }
    },
    SET_LOGS_DATA (state, data) {
        state.logs = data;
    },
    SET_CLASSIFICATIONS (state, data) {
        state.classifications = data;
    },
    SET_REQUEST_TYPES (state, data) {
        state.requestTypes = data;
    },
    SET_ITEMS (state, data) {
        state.items.splice(0, state.items.length, ...data);
    },
    SET_MODAL_ERRORS (state, data) {
        state.modal.errors = data;
    },
};
